import { createAsync } from '@solidjs/router';

// const map = new Map<
// number,
// AccessorWithLatest<ApiResponse<'getMatchDetails'> | undefined>
// >();
export const useMatchDetail = (
  matchId: Accessor<string | number>
): Accessor<ApiResponse<'matchDetail'> | undefined> => {
  // const getAsyncResult = (matchId: number) => {
  //   const detail = map.get(matchId);
  //   if (detail) {
  //     return detail
  //   }
  //   const newDetail = createAsync(() =>
  //     get.getMatchDetails({ matchId: String(matchId) })
  //   );
  //   map.set(matchId, newDetail);
  //   return newDetail
  // }

  // function read(){
  //   return getAsyncResult(matchId())()
  // }

  // createEffect(()=>{
  //   setUnwrapMatch(getAsyncResult(matchId()).latest)
  // })

  // Object.defineProperties(read,{
  //   latest:{
  //     get(){
  //       return unwrapMatch()
  //     }
  //   }
  // })
  const match = createAsync(() => get.matchDetail({ matchId: String(matchId()) }));
  const [unwrapMatch, setUnwrapMatch] = createSignal<ApiResponse<'matchDetail'> | undefined>(undefined);
  createEffect(() => {
    setUnwrapMatch(match());
  });
  return unwrapMatch;
};
